import projectConf from '../../../package.json';

export const APPLICATION_KEY = 'Club';
export const PLAYER_NAME = 'Hotmart Player Embed Web';
export const PAGE_TYPE = 'iframe';
export const SOURCE_TYPE_MAP = {
  'application/dash+xml': 'DASH',
  'application/x-mpegURL': 'HLS',
};

export const CDN_LABEL = {
  AKAMAI: 'Akamai',
  CLOUDFRONT: 'Cloudfront',
  MUX: 'Mux',
};

export const PROJECT_DEPENDENCIES = {
  PACKAGE: projectConf.version,
  PLAYER: projectConf.dependencies['video.js'],
  MUX: projectConf.dependencies['videojs-mux'],
  EME: projectConf.dependencies['videojs-contrib-eme'],
  QUALITY: projectConf.dependencies['videojs-contrib-quality-levels'],
  HTTP_STREAMING: projectConf.dependencies['@hotmart/player-http-streaming'],
};
